window._ = require('lodash');
import * as bootstrap from 'bootstrap';
import 'sweetalert2/dist/sweetalert2.min.css';

import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import {Fancybox} from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

window.sweet = require('sweetalert2');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
let cfr_token = document.querySelector('meta[name="csrf-token"]');
if (cfr_token !== null) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = cfr_token.getAttribute('content');
    window.csrf = cfr_token.getAttribute('content');
}
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles

import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiper = new Swiper('.product-images-container', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

/*import {getSlider} from "simple-slider/dist/simpleslider";

document.querySelectorAll('.product-images')
    .forEach(pblock => {
        let slider = pblock.querySelector('[data-simple-slider]');
        let prev = pblock.querySelector('[data-slider="prev"]');
        let next = pblock.querySelector('[data-slider="next"]');

        let sliderItem = getSlider(
            {
                container: slider,
                transitionTime: 1,
                delay: 5,
                paused: true,
            }
        );

        if(prev)
            prev.addEventListener('click', (e)=>{
                e.preventDefault();
                sliderItem.prev();
            })

        if(next)
            next.addEventListener('click', (e)=>{
                e.preventDefault();
                sliderItem.change(sliderItem.nextIndex());
            })


    });*/

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function lazyLoad() {
    let lazyElems = document.querySelectorAll('[data-full_src]');
    lazyElems.forEach((e) => e.src = e.getAttribute('data-full_src'));
}

function formatPrice(price) {
    return new Intl.NumberFormat('ru-RU', {
        style: 'currency', currency: 'RUB', minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(price,)
}

document.querySelectorAll('[data-pf]').forEach((elem) => {
    new PerfectScrollbar(elem, {
        wheelSpeed: 1, wheelPropagation: false, minScrollbarLength: 10, maxScrollbarLength: 50
    });
})

const phoneInputs = document.querySelectorAll('[name="phone"]');
phoneInputs.forEach((pi) => {
    pi.addEventListener('input', evt => {
        pi.value = pi.value.replace(/[^0-9+()-]/g, '');
    })
    pi.required = true;
    pi.setAttribute('minlength', 5);
    pi.setAttribute('maxlength', 18);

})


const closeButtons = document.querySelectorAll('[data-close]');
closeButtons.forEach((cb) => {
    cb.addEventListener('click', (e) => {
        let $class = cb.getAttribute('data-close');
        let elem = document.querySelectorAll(`.${$class}`);
        elem.forEach((e) => {
            if (!e.classList.contains('d-none')) e.classList.add('d-none');
        })
        document.body.classList.remove('__overlay');

        let parent = cb.closest('[data-closed]');
        if (parent && parent.querySelector('.--active'))
            parent.querySelector('.--active').classList.remove('--active');

        /*if (elem) {
            elem.classList.add('d-none');
            document.body.classList.remove('__overlay');
        }*/
    })
})

//const cityList = document.querySelectorAll('.city-list');
const openCityButtons = document.querySelectorAll('[data-open_city]');
openCityButtons.forEach((openCityButton) => {
    openCityButton.addEventListener('click', (e) => {
        e.preventDefault();
        openCityButton.classList.toggle('--active');
        let cityListType = openCityButton.getAttribute('data-open_city')
        let cityList = document.querySelector('.city-list[data-type="' + cityListType + '"]')

        if (cityList) {
            cityList.classList.toggle('d-none');
            if (cityListType !== 'mobile')
                document.body.classList.toggle('__overlay');
        }
        //cityList.forEach((cl) => cl.classList.toggle('d-none'));
    })
})

const citySearch = document.querySelectorAll('[name="city-search"]');
const cityElems = document.querySelectorAll('[data-city_elem]')
citySearch.forEach((elem) => {
    elem.addEventListener('input', (e) => {
        let val = elem.value;

        if (val.length > 0) document.querySelectorAll('.city-list-delimiter').forEach((cld) => cld.classList.add('d-none')); else document.querySelectorAll('.city-list-delimiter').forEach((cld) => cld.classList.remove('d-none'));

        cityElems.forEach((ce) => {
            if (ce.getAttribute('data-city')
                .toLowerCase()
                .indexOf(val.toLowerCase()) === -1) ce.classList.add('d-none'); else ce.classList.remove('d-none');
        })

    })
});


const openDropDownProductsButtons = document.querySelectorAll('[data-open_dropdown_product]');
openDropDownProductsButtons.forEach((oddpb) => {
    oddpb.addEventListener('click', (e) => {
        let $dropdownContainers = document.querySelectorAll('[data-dropdown_type]');
        $dropdownContainers.forEach(($dropdownContainer) => {
            if (!$dropdownContainer.classList.contains('d-none')) $dropdownContainer.classList.add('d-none');
        })
        if (document.body.classList.contains('__overlay')) document.body.classList.remove('__overlay');

        let $containerClass = oddpb.getAttribute('data-open_dropdown_product');
        let $container = document.querySelector(`[data-dropdown_type="${$containerClass}"]`);
        if ($container) {
            $container.classList.toggle('d-none')
            document.body.classList.toggle('__overlay');

            let screenWidth = window.innerWidth;
            let containerWidth = $container.offsetWidth;
            let buttonOffset = oddpb.getBoundingClientRect().left;


            let top = 47;
            if (oddpb.getBoundingClientRect().top > 70) top = 42;

            let centerX = (screenWidth - containerWidth) / 2;


            $container.style.left = centerX - buttonOffset + 'px';
            $container.style.top = top + 'px';


        }
    })
})

const questions = document.querySelectorAll('.questions-block-question');
questions.forEach((elem) => {
    let btn = elem.querySelector('.questions-block-question-text span');
    if (btn) {
        btn.addEventListener('click', (e) => {
            elem.classList.toggle('--open')
        })
    }
})

const clientTypeRadio = document.querySelectorAll('[name="client_type"]');
const urInput = document.querySelector('.__ur_input');
if (urInput) {
    clientTypeRadio.forEach((ctr) => {
        ctr.addEventListener('change', (e) => {

            if (ctr.checked && ctr.value === 'ur') {
                urInput.classList.add('d-flex');
                urInput.classList.remove('d-none');
            } else {
                urInput.classList.add('d-none');
                urInput.classList.remove('d-flex');

            }
        });
    })
}


const dopInfo = document.getElementById('dop_info-tpl');
if (dopInfo) {

    const formList = document.getElementsByTagName('form');
    for (let i = 0; i < formList.length; i++) {
        if (formList[i].id === "filterForm" || formList[i].id === "searchForm") continue;

        let firstChild = formList[i].firstChild;

        //formList[i].insertBefore(dopInfo.cloneNode(true), firstChild);
        formList[i].appendChild(dopInfo.cloneNode(true));
    }
}

function setPayType(type) {
    const orderModal = document.getElementById('orderModal');
    if (orderModal && type !== undefined) {
        let submitButton = orderModal.querySelector('[type="submit"]');
        submitButton.classList.remove('__full_pay', '__pre_pay', '__credit')
        submitButton.classList.add(`__${type}`);

        let payBlocks = orderModal.querySelectorAll('.--pay_block');
        let payTypeRadio = orderModal.querySelectorAll('[name="pay_select"]');

        try {
            orderModal.querySelector('[name="pay_type"]').value = type;
        } catch (e) {

        }
        payTypeRadio.forEach((elem) => {
            if (elem.value === type) elem.checked = true; else elem.checked = false;
        })


        payBlocks.forEach((pb) => {
            pb.style.display = 'none';

            if (pb.classList.contains(`__${type}`)) {
                pb.style.display = 'block';

            }
        })
    }
}

function initOrderModalEvents() {
    const orderModal = document.getElementById('orderModal');
    if (orderModal) {
        let payTypeRadio = orderModal.querySelectorAll('[name="pay_select"]');
        payTypeRadio.forEach((elem) => {
            elem.addEventListener('change', (e) => {
                if (elem.checked) {
                    setPayType(elem.value);
                }
            })
        })

        let colors = orderModal.querySelectorAll('[name="color"]');
        colors.forEach((color) => {
            if (color.checked) try {
                orderModal.querySelector('[name="product_color"]').value = color.value;
            } catch (e) {

            }
            color.addEventListener('change', (e) => {
                if (color.checked) try {
                    orderModal.querySelector('[name="product_color"]').value = color.value;
                } catch (e) {

                }
            })
        })
    }
}

/*
setPayType('full_pay');
initOrderModalEvents();
*/


const cardPayButtons = document.querySelectorAll('[data-pay_type]');
const orderModal = document.getElementById('orderModal');
if (orderModal) {

    cardPayButtons.forEach((cpb) => {

        cpb.addEventListener('click', evt => {
            evt.preventDefault();
            let product_id = cpb.getAttribute('data-pay_product_id');
            let product_name = cpb.getAttribute('data-pay_product_name');

            try {
                orderModal.querySelector('[name="product_id"]').value = product_id;
                orderModal.querySelector('[name="product_name"]').value = product_name;
            } catch (e) {

            }
            const payType = cpb.getAttribute('data-pay_type');

            const modalProductContainer = orderModal.querySelector('.modal-product');
            if (modalProductContainer) axios.post('/system/order-modal', {id: product_id})
                .then(response => {
                    modalProductContainer.innerHTML = response.data;
                    setPayType(payType);
                    initOrderModalEvents();
                })
                .catch(error => {
                    console.error('Ошибка при запросе:', error);
                });


            let modal = bootstrap.Modal.getOrCreateInstance(orderModal);
            modal.show();
        })
    })
}


const xhrFormsSend = document.querySelectorAll('[data-xhr="true"]');
const bModals = document.querySelectorAll('.modal');
if (xhrFormsSend.length) {
    xhrFormsSend.forEach((form) => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
            let formData = new FormData(form);
            axios.post("/system/send-form", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((res) => {
                form.querySelector('[type="submit"]').removeAttribute('disabled');


                let modalType = "";
                if (res.data.status === 'success') {
                    bModals.forEach((bm) => {
                        if (bm.classList.contains('show'))
                            modalType = bm.id;
                        let modal = bootstrap.Modal.getOrCreateInstance(bm);
                        modal.hide();
                    })
                    let sendModalElem = null;
                    if (modalType.length) {
                        if (modalType === "orderModal")
                            sendModalElem = document.getElementById('formSendModal');
                        else
                            sendModalElem = document.getElementById('questionSendModal');
                    }

                    if (sendModalElem !== null) {
                        let sendModal = bootstrap.Modal.getOrCreateInstance(sendModalElem);
                        sendModal.show();
                    }
                } else
                    sweet.fire({
                        icon: res.data.status, //iconHtml: `<span class="--send-content-icon ${res.data.status}"></span>`,
                        html: res.data.message, //confirmButtonText: buttonText,
                        showClass: {
                            popup: 'swal2-show --sw-custom-popup',
                            backdrop: 'swal2-backdrop-show',
                            icon: 'swal2-icon-show --sw-custom'
                        }
                        //footer: '<a href="">Why do I have this issue?</a>'
                    })

                form.querySelector('[type="submit"]').removeAttribute('disabled');

            })
                .catch((err) => {
                    form.querySelector('[type="submit"]').removeAttribute('disabled');
                    sweet.fire({
                        icon: 'error', //iconHtml: `<span class="--send-content-icon ${res.data.status}"></span>`,
                        html: "Возникла ошибка отправка. Попробуйте снова или напишите нам на почту.", //confirmButtonText: buttonText,
                        showClass: {
                            popup: 'swal2-show --sw-custom-popup',
                            backdrop: 'swal2-backdrop-show',
                            icon: 'swal2-icon-show --sw-custom'
                        }
                        //footer: '<a href="">Why do I have this issue?</a>'
                    })
                });
        })
    })
}

window.addEventListener('scroll', function () {

    let scrollHeight = window.scrollY;
    let firstHeader = document.querySelector('[data-header_first]');
    let secondHeader = document.querySelector('[data-header_second]');


    if (secondHeader) {
        if (scrollHeight >= secondHeader.getBoundingClientRect().height) secondHeader.classList.add('--hide'); else secondHeader.classList.remove('--hide');
    }
    if (firstHeader) {
        let subHeight = 0;
        if (secondHeader) {
            subHeight = secondHeader.getBoundingClientRect().height;
        }

        if (scrollHeight >= firstHeader.getBoundingClientRect().height + subHeight) firstHeader.classList.add('--hide'); else firstHeader.classList.remove('--hide');
    }
});

function initFancy() {
    const fancyElems = document.querySelectorAll('[data-fancybox]');
    const fancyGroups = [...new Set(
        Array.from(fancyElems).map(el => el.getAttribute('data-fancybox'))
    )];

    fancyGroups.forEach((gr) => {
        Fancybox.bind(`[data-fancybox="${gr}"]`, {});
    })
}

initFancy();

//Fancybox.bind('[data-fancybox="gallery"]', {});

/**********************************************************/

function orderButtonEventsSet() {
    let orderButtons = document.querySelectorAll('[data-target="order"]');
    let orderModalElem = document.querySelector('#orderModal')
    if (orderModalElem) {
        /* orderModalElem.addEventListener('shown.bs.modal', function (event) {
             initCounter();
         })*/

        let orderModal = bootstrap.Modal.getOrCreateInstance(orderModalElem,{
            keyboard: false,
            backdrop: 'static'
        });
        orderButtons.forEach((b) => {
            let orderType = b.getAttribute('data-order_type');

            b.addEventListener('click', (e) => {
                let productElemId = b.getAttribute('data-get_product');
                let productElem = document.querySelector(`[data-product_id="${productElemId}"]`);

                if (productElem) {
                    let productData = JSON.parse(productElem.getAttribute('data-product'));
                    let productId = productData.id;

                    const orderModalButton = orderModalElem.querySelector('[type="submit"]');
                    if (orderModalButton) {
                        orderModalButton.innerHTML = b.innerHTML;
                        orderModalButton.setAttribute('class', "");
                        orderModalButton.classList.add('--btn', '--btn-flex-center-100', `--btn-${orderType}`)
                    }


                    const modalProductContainer = orderModalElem.querySelector('.modal-product');

                    try {
                        orderModalElem.querySelector('[name="product_id"]').value = productData.id;
                        orderModalElem.querySelector('[name="product_name"]').value = productData.name;
                        orderModalElem.querySelector('[name="order_type"]').value = orderType;
                    } catch (e) {

                    }


                    if (modalProductContainer) axios.post('/system/order-modal', {id: productId, type: orderType})
                        .then(response => {
                            modalProductContainer.innerHTML = response.data;
                            orderModal.show();
                            try {
                                initCounter();
                            } catch (e) {

                            }
                        })
                        .catch(error => {
                            console.error('Ошибка при запросе:', error);
                        });

                }

            })
        });
    }
}

function calcCounterSum(count, price) {
    document.querySelectorAll('[data-select_count]')
        .forEach((e) => e.innerHTML = count);

    document.querySelectorAll('[data-select_count_price]')
        .forEach((e) => e.innerHTML = formatPrice(price * count));


}

function initCounter() {
    let counterBlock = document.querySelector('.counter-price .--counter');
    let counterInput = counterBlock.querySelector('[name="count"]');
    if (counterBlock && counterInput) {
        let singlePrice = counterInput.getAttribute('data-product_price');
        let bm = counterBlock.querySelector('[data-target="counter_minus"]');
        let bp = counterBlock.querySelector('[data-target="counter_plus"]');

        bm.addEventListener('click', (e) => {
            if (parseInt(counterInput.value) > 1) counterInput.value = parseInt(counterInput.value) - 1;

            calcCounterSum(parseInt(counterInput.value), parseFloat(singlePrice));
        });
        bp.addEventListener('click', (e) => {
            counterInput.value = parseInt(counterInput.value) + 1;
            calcCounterSum(parseInt(counterInput.value), parseFloat(singlePrice));
        });
        counterInput.addEventListener('change', (e) => {
            calcCounterSum(parseInt(counterInput.value), parseFloat(singlePrice));
        })


    }
}


orderButtonEventsSet();
const offcanvasButtons = document.querySelectorAll('[data-offcanvas_button]');
offcanvasButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        let elem = document.getElementById(btn.getAttribute('data-offcanvas_target'));
        if (elem) {
            //if (!elem.classList.contains('--visible'))
            elem.classList.toggle('--visible');
        }

        let arrCanvasList = Array.from(document.querySelectorAll('.--offcanvas'));

        if (arrCanvasList.some(elem => elem.classList.contains('--visible'))) document.body.classList.add('__overlay'); else document.body.classList.remove('__overlay');


    })
})


const filtersWithChild = document.querySelectorAll(".checkbox-container:has(.checkbox-container-child)");
filtersWithChild.forEach((fwc) => {
    let parent = fwc.querySelector('.__parent_checkbox');
    let child = fwc.querySelectorAll('.__child_checkbox');

    parent.addEventListener('change', (e) => {
        parent.classList.remove('__parts');
        child.forEach((elem) => elem.checked = parent.checked);
    })

    child.forEach((chl) => {
        chl.addEventListener('change', (e) => {
            parent.checked = Array.from(child).every(item => item.checked === true);
            let childChecked = Array.from(child).filter(item => item.checked === true).length;
            if (childChecked > 0 && childChecked < child.length) parent.classList.add('__parts'); else parent.classList.remove('__parts');

        })
    })


});

const filterBlocks = document.querySelectorAll('[data-filter]');
filterBlocks.forEach((fblock) => {
    let seeAll = fblock.querySelector('.--see-all');
    if (seeAll) {
        let hiddenElems = fblock.querySelectorAll('[data-hidden_elem]');
        seeAll.addEventListener('click', (e) => {
            if (seeAll.classList.contains('---active')) {
                hiddenElems.forEach((e) => e.style.display = 'none');
                seeAll.classList.remove('---active');
                seeAll.innerHTML = "Показать все"
            } else {
                hiddenElems.forEach((e) => e.style.display = 'block');
                seeAll.classList.add('---active')
                seeAll.innerHTML = "Скрыть"
            }
        })
    }
});

function initFullSpec(buttons) {
    buttons.forEach((btn) => {
        let productId = btn.getAttribute('data-spec_modal');
        btn.addEventListener('click', evt => {
            evt.preventDefault();
            axios.post("/system/get-spec", {id: productId})
                .then(response => response.data)
                .then((data) => {
                    let specModalElem = document.getElementById('specModal');
                    if (specModalElem) {
                        let specModal = bootstrap.Modal.getOrCreateInstance(specModalElem);
                        let contentBlock = specModalElem.querySelector('[data-spec_content]');
                        if (contentBlock) {
                            contentBlock.innerHTML = data;
                            specModal.show();
                        }
                    }
                });
        })
    });
}

const specsButtons = document.querySelectorAll('[data-spec_modal]');
initFullSpec(specsButtons);

const loadMore = document.querySelector('[data-target="load_more"]');
if (loadMore) {
    loadMore.addEventListener('click', (e) => {
        e.preventDefault();

        loadMore.disabled = true;
        loadMore.innerHTML = "Идёт загрузка";
        loadMore.classList.add('--loading');
        axios.get(loadMore.getAttribute('data-next_url'))
            .then((response) => response.data)
            .then((data) => {
                if (!data.nextPageUrl) {
                    loadMore.style.display = 'none !important';
                    loadMore.classList.add('d-none');
                    loadMore.disabled = true;
                }
                loadMore.setAttribute('data-next', data.nextPage);
                loadMore.setAttribute('data-next_url', data.nextPageUrl);

                document.getElementById('productsList')
                    .insertAdjacentHTML('beforeend', data.html);

                lazyLoad();
                orderButtonEventsSet();


                loadMore.classList.remove('--loading');
                loadMore.disabled = false;
                loadMore.innerHTML = "Показать следующие";
                new Swiper(`[data-slider="${data.uuid}"]`, {
                    // configure Swiper to use modules
                    modules: [Navigation, Pagination],
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
                let specsButtons = document.querySelectorAll(`[data-all_spec="${data.uuid}"]`);
                initFullSpec(specsButtons);
            });
    });
}

function initSelectTerminal() {
    document.querySelectorAll('[name="select-terminal"]')
        .forEach((elem) => {
            elem.addEventListener('change', (e) => {
                document.querySelectorAll('[name="address"]')
                    .forEach((inp) => inp.value = elem.value);
            })
        })
}

const cityDelivery = document.querySelector('[name="form_city_select"]');
if (cityDelivery) {
    let terminalContainer = document.querySelector('.select-office-container');
    if (terminalContainer) {
        cityDelivery.addEventListener('change', evt => {

            axios.post('/system/order-terminal', {city: cityDelivery.value})
                .then(response => {
                    terminalContainer.innerHTML = response.data;
                    try {
                        initSelectTerminal();
                    } catch (e) {

                    }
                })
                .catch(error => {
                    console.error('Ошибка при запросе:', error);
                });
        })
    }
}

window.addEventListener('load', () => {
    lazyLoad();
    const productsSection = document.querySelectorAll('section#catalog');
    productsSection.forEach((section) => {
        section.style.minHeight = `${section.getBoundingClientRect().height}px`;
    });
});


const galleryBlocks = document.querySelectorAll('[data-target="gallery_block"]');
galleryBlocks.forEach((gb) => {
    let galleryContainer = gb.querySelector('[data-target="gallery_elems"]');
    if (galleryContainer) {
        let galleryNavigation = gb.querySelector('[data-target="gallery_block_pagination"]');
        if (galleryNavigation) {
            let galleryLinks = galleryNavigation.querySelectorAll('a');
            galleryLinks.forEach((gl) => {
                gl.addEventListener('click', (e) => {
                    e.preventDefault();
                    let gtype = gl.getAttribute('data-gallery_type');
                    let ggroups = gl.getAttribute('data-gallery_groups');
                    let gpage = gl.getAttribute('data-gallery_page');
                    axios.post("/api/load-gallery", {
                        type: gtype,
                        groups: ggroups,
                        page: gpage
                    })
                        .then((response) => response.data)
                        .then((data) => {
                            galleryContainer.innerHTML = data;
                            initFancy();

                            galleryNavigation.querySelectorAll('li')
                                .forEach((li) => {
                                    li.classList.remove('--active');
                                    if (parseInt(li.getAttribute('data-gallery_page')) === parseInt(gpage))
                                        li.classList.add('--active');
                                })

                        });
                })
            })
        }
    }
});


